import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteFieldFormAction,
  getFieldFormAction,
} from "../../Actions/Section&FieldAction/SectionFieldAction";
import { RxDropdownMenu, RxUpdate } from "react-icons/rx";
import AddDropDownValueModal from "../../Modal/Section&FieldModal/AddDropDownValueModal";
import LoadingPage from "../Loading/LoadingPage";
import { IoArrowBack } from "react-icons/io5";
import { FaTrash } from "react-icons/fa6";
import DeleteModal from "../../Modal/DeleteModal";
import { PiEyeFill } from "react-icons/pi";
import FieldsModal from "../../Modal/Section&FieldModal/FieldsModal";

const ShowFields = () => {
  const { id: sectionFormId } = useParams();
  const getFields = useSelector((state) => state.getFields);
  const { fields, loading } = getFields;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFieldFormAction(sectionFormId));
  }, [sectionFormId]);
  const [fieldId, setFieldId] = useState(null);
  const [isOpenDropdownModal, setIsOpenDropdownModal] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenFieldModal, setIsOpenFieldModal] = useState(false);
  const handleDelete = () => {
    dispatch(deleteFieldFormAction(fieldId));
    dispatch(getFieldFormAction(sectionFormId));
    dispatch(getFieldFormAction(sectionFormId));
  };
  return (
    <div className="m-auto w-[98%]">
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="pt-3 px-3">
            <button
              onClick={() => navigate(-1)}
              className="btn-indigo justify-between group lg:w-1/12"
            >
              Back
              <p className="group-hover:-translate-x-1 duration-300">
                <IoArrowBack />
              </p>
            </button>
          </div>
          <div className="parent-table">
            <table>
              <thead className="coustm-thead">
                <tr>
                  <th className="coustm-th py-2 px-1">#</th>
                  <th className="coustm-th py-2 px-1">Name</th>
                  <th className="coustm-th py-2 px-1">Label</th>
                  <th className="coustm-th py-2 px-1">Placeholder</th>
                  <th className="coustm-th py-2 px-1">type</th>
                  <th className="coustm-th py-2 px-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {fields?.map((field, index) => {
                  return (
                    <tr className="coustm-tr" key={index}>
                      <td className="coustm-td">{index + 1}</td>
                      <td className="coustm-td">{field.name}</td>
                      <td className="coustm-td">{field.label}</td>
                      <td className="coustm-td">{field.placeholder}</td>
                      <td className="coustm-td">{field.type}</td>
                      <td className="coustm-td  text-center ">
                        <div className="flex gap-2  items-center">
                          <button
                            onClick={() => {
                              setIsOpenFieldModal(true);
                              setFieldId(field?.id);
                            }}
                            className="btn-indigo"
                          >
                            Update <RxUpdate />
                          </button>

                          <button
                            onClick={() => {
                              setIsOpen(true);
                              setFieldId(field?.id);
                            }}
                            className="btn-red"
                          >
                            Delete <FaTrash />
                          </button>

                          {field.type == "dropdown" && (
                            <button
                              onClick={() =>
                                navigate(`/showValues/${field?.id}`)
                              }
                              className="btn-blue"
                            >
                              Show Values <PiEyeFill />
                            </button>
                          )}
                          {field.type == "dropdown" ? (
                            <button
                              onClick={() => {
                                setIsOpenDropdownModal(true);
                                setFieldId(field.id);
                              }}
                              className="btn-warning m-0  flex  items-center capitalize"
                            >
                              drop down value
                              <RxDropdownMenu />
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <DeleteModal
        isOpen={isOpen}
        id={fieldId}
        onDelete={handleDelete}
        onClose={() => setIsOpen(false)}
      />
      {isOpenDropdownModal && (
        <AddDropDownValueModal
          closeModal={() => setIsOpenDropdownModal(false)}
          fieldId={fieldId}
        />
      )}

      {isOpenFieldModal && (
        <FieldsModal
        id={fieldId}
          sectionFormId={sectionFormId}
          closeModal={() => setIsOpenFieldModal(false)}
        />
      )}
    </div>
  );
};

export default ShowFields;
